export class AppUrlConstant {
  public static readonly URL_SEPARATOR = '/';
  public static readonly UNAUTHORIZED = 'unauthorized';
}
